/**
 * @fileoverview GET handler for the "/engagement/query_builder/credits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementQueryBuilderCredits } from "./constants";
import type { QueryBuilderCreditsResult } from "./types";

export const getEngagementQueryBuilderCredits = reactQueryFetcherAdapter(
  engagementQueryBuilderCredits,
  (signal: AbortSignal): Promise<QueryBuilderCreditsResult> => {
    return fetch("/engagement/query_builder/credits", "GET", {}, { signal });
  }
);
